export default __webpack_public_path__ + "static/media/connecion.9005bc4b.png";